import { getTenantProducts, getCommonProducts, TenantProductQueryParams, CommonProductQueryParams } from '../../shared/tenant';
import { getTenant } from '../../admin/tenant';
import { TenantQueryParams } from '../../../../contract/dtos';

export const tenantQueries = {
  queries: {
    tenantProducts: (params?: TenantProductQueryParams) => ({
      queryKey: ['shared', 'tenant-products', ...(params ? [params] : [])],
      queryFn: async () => {
        return getTenantProducts(params);
      }
    }),
    commonProducts: (params?: CommonProductQueryParams) => ({
      queryKey: ['shared', 'common-products', ...(params ? [params] : [])],
      queryFn: async () => {
        return getCommonProducts(params);
      }
    }),
    tenant: (params?: TenantQueryParams) => ({
      queryKey: ['shared', 'tenant', ...(params ? [params] : [])],
      queryFn: async () => {
        return getTenant(params);
      }
    })
  }
};